import {Locales} from '@netx/core-next/locales/utils/Locales';
import {FileFormatType} from './constants';

export const FileFormatTypeLabel: Record<FileFormatType, string> = Locales(
	(i18n) => ({
		[FileFormatType.EXCLUDE]: i18n('i18n.exclude'),
		[FileFormatType.ONLY]: i18n('i18n.only'),
	}),
);
